export class PropertyError extends Error {
    constructor(message) {
        super(message); 
        this.name = "PropertyError"; 
    }
}
